import { Circle } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheckCircleHollow = mkIcon(Circle);